var render = function (_h,_vm) {var _c=_vm._c;return _c('b-container',_vm._b({class:[_vm.data.staticClass, _vm.data.class],attrs:{"fluid":""}},'b-container',_vm.data.attrs,false),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }